'use client'

import { type ComponentProps } from 'react'

import { ButtonDefault } from '@/components/common/Button'
import { Splash } from '@/components/common/Splash'
import { StyledList } from '@/components/common/StyledList'
import { Icon } from '@/components/icons/Icon'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { CARDART } from '@/defs/misc'

import styles from './HomeAbout.module.scss'
import { HomeAboutChart } from './HomeAboutChart/HomeAboutChart'

const BULLETS: ComponentProps<typeof StyledList>['items'] = [
  {
    content: (
      <>
        The premier data-driven <em>Magic: The Gathering</em> Commander/EDH deck-building resource.
      </>
    ),
    icon: 'edhrecGraphic',
  },
  {
    content: <>A one-stop-shop to help you search or browse to find the perfect commander and 99.</>,
    icon: 'cards',
  },
  {
    content: <>Hub for daily articles about EDH/Commander.</>,
    icon: 'newspaper',
  },
  {
    content: <>Advanced tools and filters to enable high level data analysis, like this Trending Cards graph!</>,
    icon: 'chartSimple',
  },
]

export const HomeAbout = () => (
  <section className={styles.container}>
    <Splash align='left' aspectRatio='1' backgroundImages={[CARDART.SOL_RING]} subtle />
    <div className={styles.content}>
      <div className={styles.about}>
        <h2 className={styles.heading}>
          What is <Icon name='edhrecText' />?
        </h2>
        <div className={styles.bullets}>
          <StyledList items={BULLETS} />
        </div>
        <ButtonDefault as='LinkRoute' href='/about-us' size='lg'>
          <IconWithLabel iconAfter='caretRight'>About Us</IconWithLabel>
        </ButtonDefault>
      </div>
      <HomeAboutChart />
    </div>
  </section>
)
